import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { DateSelectService } from './date-select.service';

@Injectable({
  providedIn: 'root'
})
export class DemandOverviewDataService {

  // Set up DemandOverview BehaviorSubject
  private demandOverviewSource = new BehaviorSubject<DemandOverviewReach[]>([]);
  currentDemandOverview = this.demandOverviewSource.asObservable();

  constructor(private http: HttpClient, private dateSelectObject: DateSelectService, @Inject('BASE_URL') private baseUrl: string) {

    // Whenever you get a date, grab the demand overview data
    this.dateSelectObject.currentDate.subscribe((result) => {
      this.getDemandOverview(result);
    });

  }

  // Call API to get new DemandOverview data
  // HARDCODED CONDITION IN SERVICE AND CONTROLLER
  getDemandOverview(date) {
    this.http.get<DemandOverviewReach[]>(`${this.baseUrl}api/DemandOverview/${date}`).subscribe(
      result => {
        if (result) {
          this.changeDemandOverview(result);
        }
      },
      error => console.error(error)
    );
  }

  // Update DemandOverview BehaviorSubject
  changeDemandOverview(demandOverview) {
    this.demandOverviewSource.next(demandOverview);
  }

}

// DemandOverviewData contains an array of DemandOverviewReach objects
export interface DemandOverviewReach {
  demandDayOfYear: number,
  excessFlowDate: string,
  reachNumber: number,
  reachName: string,
  demandConditionId: number,
  naturalFlow: number,
  potentialDemand: number,
  adjustedDemand: number | null,
  actualDemand: number,
  excessFlow: number
}
